/* istanbul ignore file */
export { default } from './WhatsAppAndCallButtons';
